import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { DashBoardService } from 'app/main/pages/dashboard/dashboard.services';
import { ChartOptions, ChartType, ChartConfiguration } from 'chart.js';

import { takeUntil } from 'rxjs/operators';
import { DestroyableComponent } from 'app/main/destroyable.component';
import chartColors from './../chart-colors';

@Component({
    selector: 'sourcemarkets',
    templateUrl: './sourcemarkets.component.html',
    styleUrls: ['../dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SourceMarketsComponent extends DestroyableComponent implements OnInit{
	public sourcemarkets: number[];
	public sourcelabel: string[];
	public chartData: ChartConfiguration<'doughnut'>['data'];
	public showLoader: boolean;

	/**
	 * Chart SourceMarkets
	 */
	// Pie
	public pieChartOptions: ChartOptions<'doughnut'> = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				position: 'left',
				labels: {
					usePointStyle: true
				}
			},
			tooltip: {
				cornerRadius: 8,
				padding: { top: 6, bottom: 6, left: 8, right: 8 },
				caretSize: 0,
				caretPadding: 10,
				backgroundColor: '#b5b5b5',
				displayColors: false,
				callbacks: {
					label: function(tooltipItem): string {
						const n = Number(tooltipItem.parsed);
						if(!n || isNaN(n)) return '';
						return n.toLocaleString('US');
					},
					title: function(items): string{
						return;
					},
				},
			},
			// TODO datalabels
		}
	};
	public pieChartType: ChartType = 'doughnut';
	public pieChartLegend = true;

	constructor(public dashboardService: DashBoardService){
		super();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	public ngOnInit(): void{
		this.dashboardService.sourceMarketResponse
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe({
			next: (response: any) => {
				this.onData(response);
			}
		});
	}
	// -----------------------------------------------------------------------------------------------------

	public onData(response: any): void{
		this.showLoader = true;

		if(!response) return;
		else if (response.length > 0){
			this.showLoader = false;
		}

		const data = [];
		
		for (const item of response) {
			data.push({
				'value': Number(item.percent_pax).toFixed(2),
				'label': item.nation_code
			});
		}

		data.sort((a, b) => {
			return b.value - b.value;
		});

		this.sourcemarkets = data.map(item => item.value);
		this.sourcelabel = data.map(item => item.label);
		const colors = [];
		for (let i = 0; i < data.length; i++) {
			colors.push(chartColors[i]);
		}
		this.chartData = {
			labels: this.sourcelabel,
			datasets: [
				{
					data: this.sourcemarkets.map(v => Number(v)),
					backgroundColor: colors
				}
			]
		};
	}
	
}
